import { Image, ValImage } from '@valbuild/next';
import useEmblaCarousel from 'embla-carousel-react';
import AutoScroll from 'embla-carousel-auto-scroll';

export interface Props {
  images: Image[];
}

const ASPECT_RATIO_STYLES = ['aspect-[5/7]', 'aspect-[4/5]', 'aspect-square'];

const ImageCarousel: React.FC<Props> = ({ images }) => {
  const [carouselRef] = useEmblaCarousel({ loop: true }, [
    AutoScroll({
      speed: 0.5,
      stopOnInteraction: false,
    }),
  ]);

  return (
    <div
      className="embla overflow-hidden -mx-16 tablet:-mx-24"
      ref={carouselRef}
    >
      <div className="embla__container flex gap-24 pl-24  items-center">
        {images.map((image, index) => {
          const aspectStyle =
            ASPECT_RATIO_STYLES[index % ASPECT_RATIO_STYLES.length];
          return (
            <div
              key={index}
              className={`embla__slide min-w-0 flex-[0_0_80%] tablet:flex-[0_0_50%] laptop:flex-[0_0_25%]`}
            >
              <ValImage
                src={image}
                className={`${aspectStyle} object-cover`}
                sizes="(max-width: 768px) 80vw, (max-width: 1024px) 50vw,(max-width: 1920px) 25vw, 480px"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ImageCarousel;
